import { useContext } from "react";
import { Button } from "@mui/material";
import { dateFormat } from "../tools";
import moment from "moment";
import SchedulerContext from "./schedulerContext";
import { useTranslation } from "react-i18next";

export default function ClearAll() {
  const { t } = useTranslation();
  const { eventsDispatch = () => false } = useContext(SchedulerContext);
  const handleDelete = () =>
    eventsDispatch({
      type: "DELETE_RANGE",
      payload: {
        start: moment().startOf("date").format(dateFormat),
        endDay: moment().add(1000, "years").format(dateFormat),
      },
    });
  return (
    <Button onClick={handleDelete} color="secondary">
      {t("scheduler.clearAll")}
    </Button>
  );
}
